import React, { useState, useEffect } from "react";

export default function useMobileViewportHeight(ref, shouldScroll) {
  const [viewport, setViewport] = useState({
    maxHeight: "100vh",
    maxWidth: "100vw",
  });

  const updateViewport = () => {
    setViewport({
      maxHeight: window.visualViewport.height + "px",
      maxWidth: window.visualViewport.width + "px",
    });
    if (ref?.current && shouldScroll) {
      const { bottom, top } = ref.current.getBoundingClientRect();

      const height = bottom - top;
      const scrollTo = bottom - height;

      // window.scrollTo(0, ref.current.offsetTop);
      window.scrollTo(0, scrollTo);
      // console.log("SCROLLING TO", ref.current.offsetTop);
    }
  };

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      typeof window.visualViewport !== "undefined"
    ) {
      updateViewport();
      window.visualViewport.addEventListener("resize", updateViewport);
      window.visualViewport.addEventListener("scroll", updateViewport);
      return () => {
        window.visualViewport.removeEventListener("resize", updateViewport);
        window.visualViewport.removeEventListener("scroll", updateViewport);
      };
    }
  }, []);

  return [viewport, updateViewport];
}
